import { infoIconGray } from '../../../../assets/hostedassets';
import { FETCH_DETAILS_BANNER_COPY } from './ManagementProfileTabConstants';
import styles from './FetchDetailsBanner.module.scss';

interface FetchDetailsBannerProps {
    onFetchDetails: () => void;
}

// First-run prompt (D7) — a single inline info row, not dismissible. Replaced by the tab's
// existing in-progress treatment once a fetch is running (moduleFetchInFlight), so this
// component owns no loading/progress UI of its own. The CTA just opens the Unlock/Refresh
// drawer (synchronous) — no request fires from this click, so no disabled/pending state either.
function FetchDetailsBanner({ onFetchDetails }: FetchDetailsBannerProps) {
    return (
        <div className={styles.FetchDetailsBanner}>
            <img src={infoIconGray} alt="" className={styles.icon} />
            <span className={styles.text}>
                {FETCH_DETAILS_BANNER_COPY.BODY}{' '}
                <button type="button" className={styles.cta} onClick={onFetchDetails}>
                    {FETCH_DETAILS_BANNER_COPY.CTA_LABEL}
                </button>
            </span>
        </div>
    );
}

export default FetchDetailsBanner;
